/**
 * @generated SignedSource<<83153a6c6ace2465a6526d8cf88243c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
export type RoutineNotificationStrategy = "DISABLED" | "STANDARD";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type CreateRoutineInput = {
  connections?: ReadonlyArray<AddConnection> | null;
  description?: string | null;
  descriptionFileIds?: ReadonlyArray<string> | null;
  descriptionImageIds?: ReadonlyArray<string> | null;
  icon?: RoutineIcon | null;
  newSchedule?: RoutineScheduleInput | null;
  notificationStrategy?: RoutineNotificationStrategy | null;
  schedule?: ScheduleInput | null;
  sections?: ReadonlyArray<UpdateRoutineCreateSectionInput> | null;
  startAt?: string | null;
  tasks?: ReadonlyArray<CreateTaskInput> | null;
  teamId?: string | null;
  title: string;
  type?: RoutineType | null;
};
export type AddConnection = {
  check?: CreateTaskSectionConnetion | null;
  number?: CreateTaskNumberExistingSectionConnetion | null;
  text?: CreateTaskSectionConnetion | null;
};
export type CreateTaskSectionConnetion = {
  canBeDisabled?: boolean | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type CreateTaskNumberExistingSectionConnetion = {
  canBeDisabled?: boolean | null;
  greaterThan?: number | null;
  lessThan?: number | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type RoutineScheduleInput = {
  daily?: RoutineScheduleDailyInput | null;
  monthly?: RoutineScheduleMonthlyInput | null;
  weekly?: RoutineScheduleWeeklyInput | null;
};
export type RoutineScheduleDailyInput = {
  deadlineDuration?: number | null;
  isAllDay?: boolean | null;
  weekdays: ReadonlyArray<RoutineScheduleDailyWeekdayInput>;
};
export type RoutineScheduleDailyWeekdayInput = {
  startTime?: TimeInput | null;
  tasks: ReadonlyArray<RoutineScheduleTaskImportanceInput>;
  weekday: number;
};
export type TimeInput = {
  hour: number;
  minute: number;
};
export type RoutineScheduleTaskImportanceInput = {
  importance: TaskImportance;
  taskId: string;
};
export type RoutineScheduleMonthlyInput = {
  endDay?: number | null;
  months: ReadonlyArray<number>;
  startDay: number;
};
export type RoutineScheduleWeeklyInput = {
  endWeekday?: number | null;
  startTime?: TimeInput | null;
  startWeekday?: number | null;
  weeks?: ReadonlyArray<number> | null;
};
export type ScheduleInput = {
  rules: ReadonlyArray<RecurrenceRuleInput>;
  type?: RoutineScheduleType | null;
  tzid?: string | null;
};
export type RecurrenceRuleInput = {
  byhour?: ReadonlyArray<number> | null;
  byminute?: ReadonlyArray<number> | null;
  bymonth?: ReadonlyArray<number> | null;
  bymonthday?: ReadonlyArray<number> | null;
  bysecond?: ReadonlyArray<number> | null;
  byweekday?: ReadonlyArray<number> | null;
  byweekno?: ReadonlyArray<number> | null;
  byyearday?: ReadonlyArray<number> | null;
  dtstart?: string | null;
  duration?: number | null;
  freq: RecurrenceFrequency;
  interval?: number | null;
  isAllDay?: boolean | null;
  tasks: ReadonlyArray<RecurrenceRuleTaskDescriptionInput>;
  until?: string | null;
  wkst?: number | null;
};
export type RecurrenceRuleTaskDescriptionInput = {
  importance: TaskImportance;
  taskId: string;
};
export type UpdateRoutineCreateSectionInput = {
  canBeDisabled?: boolean | null;
  id: string;
  orgTopicId?: string | null;
  teamId?: string | null;
  title?: string | null;
};
export type CreateTaskInput = {
  check?: CreateTaskCheckInput | null;
  number?: CreateTaskNumberInput | null;
  text?: CreateTaskTextInput | null;
};
export type CreateTaskCheckInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  sentiments?: ReadonlyArray<TaskSentiment> | null;
  title?: string;
};
export type CreateTaskNumberInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  suffix?: string | null;
  title: string;
  unit?: NumberTaskUnit | null;
};
export type CreateTaskTextInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  title?: string;
};
export type KPICreateMutation$variables = {
  input: CreateRoutineInput;
};
export type KPICreateMutation$data = {
  readonly createRoutine: {
    readonly id: string;
  } | null;
};
export type KPICreateMutation = {
  response: KPICreateMutation$data;
  variables: KPICreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "createRoutine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPICreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPICreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29d05d9cc02ae52ca576330bda0f676e",
    "id": null,
    "metadata": {},
    "name": "KPICreateMutation",
    "operationKind": "mutation",
    "text": "mutation KPICreateMutation(\n  $input: CreateRoutineInput!\n) {\n  createRoutine(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e90268dec11b90368af1bda14c83442";

export default node;
